export default __webpack_public_path__ + "static/assets/images/harvard-logo.e82f285fc1fa903d1325f3de43a9c7ec.svg";